import { render, staticRenderFns } from "./rekonfakr.vue?vue&type=template&id=6c9f7164"
import script from "./rekonfakr.vue?vue&type=script&lang=js"
export * from "./rekonfakr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports